import React from 'react';
import { useFela } from 'react-fela';
import { useSelector } from 'react-redux';
import {
  Text,
  Section,
  PlayerSpinner,
} from '../common';
import ConnectedIcon from '../ControlBar/Chromecast/ConnectedIcon';
import { smallScreen } from '../../../common/mixins';

const overlayRules = ({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.overlayDarkHeavy,
  bottom: '0',
  color: theme.color.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: '0',
  paddingBottom: '40px', // skip progress bar
  position: 'absolute',
  right: '0',
  top: '0',
});

const textSectionRules = ({ theme }) => ({
  fontSize: theme.fontSize.sectionHeading,
  extend: [
    smallScreen({
      fontSize: theme.fontSize.normal,
    }),
  ],
});

const textHeadingRules = ({ theme }) => ({
  fontSize: theme.fontSize.pageHeading,
  fontWeight: 'bold',
  extend: [
    smallScreen({
      fontSize: theme.fontSize.medium,
    }),
  ],
});

const spinnerContainerRules = ({ visible }) => ({
  position: 'relative',
  height: 'auto',
  visibility: visible ? 'visible' : 'hidden',
});

const spinnerRules = {
  width: '3em',
  height: '3em',
};

function ChromecastOverlay() {
  const { css } = useFela();
  const {
    deviceName,
    isBuffering,
  } = useSelector(({ playback }) => ({
    deviceName: playback.chromecastFriendlyName,
    isBuffering: playback.isBuffering,
  }));

  return (
    <div className={css(overlayRules)}>
      <ConnectedIcon size="large" />

      <Section marginTop="large">
        <Text
          id="chromecast.castingTo"
          color="light"
          className={css(textSectionRules)}
        />
      </Section>
      <Section marginBottom="large">
        <Text
          bold
          color="light"
          className={css(textHeadingRules)}
          // eslint-disable-next-line max-len
          // deviceName is HTML-escaped https://developers.google.com/cast/docs/reference/chrome/chrome.cast.Receiver#friendlyName
          dangerouslySetInnerHTML={{ __html: deviceName }}
        />
      </Section>
      <PlayerSpinner
        visible={isBuffering}
        extendContainer={spinnerContainerRules}
        extendSpinner={spinnerRules}
      />
    </div>
  );
}

export default React.memo(ChromecastOverlay);
